const __DEV__ = false;

var getOwnerDoc = function getOwnerDoc(node) {
  return node && node.ownerDocument || document;
};
var getOwnerDoc$1 = getOwnerDoc;

export { getOwnerDoc$1 as default };
//# sourceMappingURL=get-owner-doc.js.map
